const localDevelopment = process.env.NODE_ENV === "development";
// Local development mirrors the live site by default: the CRA dev server
// proxies same-origin /api, /users, /permissions, and /views requests to the
// hosted backend (see setupProxy.js), so every account works without a local
// database. Set REACT_APP_API_BASE=http://127.0.0.1:8000 to use a local
// backend instead.
const configuredBase = process.env.REACT_APP_API_BASE || (
  localDevelopment ? "" : "https://steam-backend-fda2.onrender.com"
);

const normalizedBase = configuredBase.replace(/\/+$/, "").replace(/\/api$/, "");
// An empty configured base means same-origin: resolve against the page origin
// so API_ORIGIN stays absolute and every caller keeps working unchanged.
export const API_ORIGIN = normalizedBase ||
  (typeof window !== "undefined" && window.location ? window.location.origin : "");
export const API_BASE = `${API_ORIGIN}/api`;
export const TIKTOK_ADMIN_API_BASE = (
  process.env.REACT_APP_TIKTOK_ADMIN_API_BASE || `${API_BASE}/admin/tiktok`
).replace(/\/+$/, "");
export function apiHeaders(headers = {}) {
  const token = localStorage.getItem("mg_token");
  return { ...headers, ...(token ? { Authorization: `Bearer ${token}` } : {}) };
}